<div class="main-table">
    <div class="main-table-toolbar">
        <div class="main-toolbar-container">
            <div class="main-toolbar-add">
                <button
                    mat-stroked-button
                    (click)="onAdd()"
                >
                    <mat-icon>add</mat-icon>
                    Neuer Datensatz
                </button>
            </div>
            <div class="main-toolbar-spacer"></div>

            <div class="main-toolbar-filter-container">
                <div class="main-toolbar-filter">
                    <div class="filter-item">
                        <ng-container *transloco="let t">
                            <pixl-free-filter-input
                                [label]="t('name_or_id')"
                                [matIcon]="'search'"
                                [hint]="getSearchFilterHint()"
                                [minLength]="freeFilterLen"
                                (onKeyUpChange)="setFreeFilter($event)"
                            />
                        </ng-container>
                    </div>

                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>Anwendungen</mat-label>
                            <mat-select
                                multiple
                                (valueChange)="setConsumerFilter($event)"
                            >
                                @for (consumer of consumers$ | async; track consumer) {
                                <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>Fächer</mat-label>
                            <mat-select
                                multiple
                                (valueChange)="setSubjectFilter($event)"
                            >
                                @for (subject of subjects$ | async; track subject) {
                                <mat-option [value]="subject.treeId">{{ subject.name }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-header-overlay"></div>

        <div class="table-container mat-elevation-z4">
            @if (tests$ | async; as tests) {
            <table
                mat-table
                [dataSource]="tests"
                [trackBy]="trackById"
            >
                <ng-container matColumnDef="actions">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Aktionen</th>

                    <td
                        mat-cell
                        *matCellDef="let test"
                    >
                        <button
                            [class.btn-success]="coloredButtonsEnabled()"
                            mat-icon-button
                            aria-label="Edit"
                            (click)="onEdit(test)"
                            matTooltip="Datensatz editieren"
                        >
                            <mat-icon>edit</mat-icon>
                        </button>

                        <button
                            [class.btn-info]="coloredButtonsEnabled()"
                            mat-icon-button
                            aria-label="Copy"
                            (click)="onCopy(test)"
                            matTooltip="Datensatz duplizieren"
                        >
                            <mat-icon>content_copy</mat-icon>
                        </button>

                        <button
                            [class.btn-danger]="coloredButtonsEnabled()"
                            mat-icon-button
                            color="warn"
                            aria-label="Delete"
                            (click)="onDelete(test)"
                            matTooltip="Datensatz löschen"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>

                        <button
                            [class.btn-primary]="coloredButtonsEnabled()"
                            mat-icon-button
                            aria-label="Preview"
                            matTooltip="Vorschau"
                            (click)="previewPlayer2(test)"
                        >
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="id">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >ID</th>
                    <td
                        mat-cell
                        *matCellDef="let test"
                    >{{ test.id }}</td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Name</th>
                    <td
                        mat-cell
                        *matCellDef="let test"
                    >{{ test.name }}</td>
                </ng-container>

                <ng-container matColumnDef="consumers">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Anwendung</th>
                    <td
                        mat-cell
                        *matCellDef="let test"
                    >{{ getConsumerName(test.consumers.id) }}</td>
                </ng-container>

                <ng-container matColumnDef="subjects">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Fach</th>
                    <td
                        mat-cell
                        *matCellDef="let test"
                    >{{ getSubjectName(test.subjects.id) }}</td>
                </ng-container>

                <ng-container matColumnDef="sequenceCount">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Anzahl<br />Sequenzen</th>
                    <td
                        mat-cell
                        *matCellDef="let test"
                    >
                        {{ test.sequences?.length || 0 }}
                    </td>
                </ng-container>

                <ng-container
                    matColumnDef="sequences"
                    class="column-sequences"
                >
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Sequenzen</th>
                    <td
                        mat-cell
                        *matCellDef="let test"
                    >
                        @if (test.sequences?.length) {

                        @for (name of getSequencesArray(test.sequences); track name) {
                        <span class="badge badge-dark me-1">
                            {{ name }}
                        </span>
                        } } @else {
                        ---
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="version">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Version</th>
                    <td
                        mat-cell
                        *matCellDef="let test"
                    >{{ test.version }}</td>
                </ng-container>

                <ng-container matColumnDef="updated">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Letzte Änderung</th>
                    <td
                        mat-cell
                        *matCellDef="let test"
                    >{{ test.updated ? (test.updated | date: "dd.MM.yyyy HH:mm") + " Uhr" : "" }}</td>
                </ng-container>

                <ng-container matColumnDef="changedBy">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Geändert von</th>
                    <td
                        mat-cell
                        *matCellDef="let test"
                    >{{ test.changedBy }}</td>
                </ng-container>

                <ng-container matColumnDef="created_at">
                    <th
                        mat-header-cell
                        *matHeaderCellDef
                    >Erstellt am</th>
                    <td
                        mat-cell
                        *matCellDef="let test"
                    >{{ test.created_at ? (test.created_at | date: "dd.MM.yyyy HH:mm") + " Uhr" : "" }}</td>
                </ng-container>

                <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumns"
                ></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    [class.selected-row]="currentSelectedRow() === row.id"
                ></tr>
            </table>

            } @else {
            <pixl-table-loading-spinner [name]="'Tests'" />
            }
            <mat-paginator
                [pageIndex]="pageChange().pageIndex"
                [pageSize]="pageChange().pageSize"
                [pageSizeOptions]="[25, 50, 100]"
                [length]="totalItems">
            </mat-paginator>
        </div>
    </div>
</div>